// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","rulesImg":"Modal_rulesImg__V4KCL","header":"Modal_header__VdBgK"};